export const appMessage = (message = '', severity = 'error') => ({
    type: 'APPLICATION_MESSAGE',
    message,
    severity
});
export const appMessageClose = () => ({ type: 'APPLICATION_CLOSE_MESSAGE' });
export const toggleModal = (modal = '', id = 0, name = '', data) => ({
    type: 'APPLICATION_MODAL',
    modal,
    itemId: id,
    itemName: name,
    data
});
export const toggleConditions = (modal, accepted) => ({
    type: 'TOGGLE_CONDITIONS',
    modalKey: modal,
    accepted
});
